import { getSearchStore } from '../store/Store';

export const getSearchSessionId = () => getSearchStore().searchSessionId;
